import { render } from "./CVView.vue?vue&type=template&id=35a78b28&scoped=true&ts=true"
import script from "./CVView.vue?vue&type=script&lang=ts"
export * from "./CVView.vue?vue&type=script&lang=ts"

import "./CVView.vue?vue&type=style&index=0&id=35a78b28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a78b28"]])

export default __exports__